import { IAdvertising } from '@loquis/shared';
import { GameCtx } from '../../core/context/game.context';

export const gameReducer = (state: IGameState, action: { type: string; payload?: any }): IGameState => {
  switch (action.type) {
    case 'init':
      return {
        ...state,
        ...action.payload,
        loquisEnded: false,
        pendingAdv: null,
        noResponse: true,
        phase: 'waiting-for-user-action',
      };
    case 'questionOK':
      if (!state.noResponse) return state;

      return {
        ...state,
        answerOKIdx: action.payload.answerOKIdx,
        correctAnswerIdx: action.payload.answerOKIdx,
        answeredQuestionsCounter: action.payload.answeredQuestionsCounter,
        wrongQuestionsCounter: action.payload.wrongQuestionsCounter,
        score: action.payload.score,
        isEndGame: action.payload.isEndGame,
        userResponseCD: 0,
        noResponse: false,
        phase: 'playing-loquis',
      };
    case 'questionKO':
      if (!state.noResponse) return state;

      return {
        ...state,
        wrongQuestionsCounter: action.payload.wrongQuestionsCounter,
        userResponseCD: 0,
        answeredQuestionsCounter: action.payload.answeredQuestionsCounter,
        score: action.payload.score,
        isEndGame: action.payload.isEndGame,
        error: [...state.error, action.payload.newError],
        correctAnswerIdx: action.payload.correctAnswerIdx ?? -1,
        noResponse: false,
        phase: 'playing-loquis',
      };
    case 'questionTimeout':
      if (!state.noResponse) return state;

      return {
        ...state,
        wrongQuestionsCounter: action.payload.wrongQuestionsCounter,
        userResponseCD: 0,
        answeredQuestionsCounter: action.payload.answeredQuestionsCounter,
        score: action.payload.score,
        isEndGame: action.payload.isEndGame,
        error: [],
        answerOKIdx: -1,
        correctAnswerIdx: action.payload.correctAnswerIdx ?? -1,
        noResponse: false,
        phase: 'playing-loquis',
      };
    case 'loquisEnd':
      return {
        ...state,
        skipCountdown: 0,
        loquisEnded: true,
      };
    case 'decrementSkipCountdown':
      return {
        ...state,
        skipCountdown: state.skipCountdown > 0 ? state.skipCountdown - 1 : 0,
      };
    case 'pushAdv':
      return {
        ...state,
        pendingAdv: action.payload,
      };
    case 'playAdv':
      return {
        ...state,
        phase: 'playing-adv',
      };
    case 'setIsEndGame':
      return {
        ...state,
        isEndGame: action.payload,
      };
    case 'decrementUserResponseCD':
      const _userResponseCD = state.userResponseCD > 0 ? state.userResponseCD - 1 : 0;

      return {
        ...state,
        userResponseCD: _userResponseCD,
      };
  }
};

export const initState = (gameCtx: GameCtx): IGameState => ({
  progressButtonTO: gameCtx.getPreset().skipTO,
  loquisEnded: false,
  answeredQuestionsCounter: 0,
  wrongQuestionsCounter: 0,
  isEndGame: false,
  userResponseCD: gameCtx.getPreset().userResponseTO,
  skipCountdown: gameCtx.getPreset().skipTO,
  answerOKIdx: -1,
  correctAnswerIdx: -1,
  score: 0,
  error: [],
  phase: '',
  pendingAdv: null,
  noResponse: true,
});

interface IGameState {
  pendingAdv: IAdvertising;
  progressButtonTO: number;
  loquisEnded: boolean;
  answeredQuestionsCounter: number;
  wrongQuestionsCounter: number;
  isEndGame: boolean;
  userResponseCD: number;
  skipCountdown: number;
  answerOKIdx: number;
  correctAnswerIdx: number;
  score: number;
  error: number[];
  phase: 'waiting-for-user-action' | 'playing-loquis' | 'playing-adv' | '';
  noResponse: boolean;
}
